// see here: https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-every-transition
// core
import React from 'react';
import { useEffect } from 'react';
// hooks

export default function RedirectTo({url})
{
    useEffect(() =>
    {
        if(url !== null)
        {
            setTimeout(() =>
            {
                window.location.replace(url);
            }, 500)
        }
    }, [url]);

    return (
        <div>
            <p>Redirecting, please wait...</p>
            <p><a href={url}>Click here if the page doesn't load</a></p>
        </div>
    )
}
